import "@/App.css";
import { MapExperience } from "@/components/landing/MapExperience";

function App() {
  return (
    <div data-testid="app-root" className="min-h-screen bg-transparent text-[#121212] font-sans antialiased">
      <MapExperience />
    </div>
  );
}

export default App;
